var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fb-container"},[_vm._m(0),_c('FeedbackTable',{attrs:{"feedbacks":_vm.allFeedbacks}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fb-top-pane flex align-center"},[_c('h2',[_vm._v("Feedbacks")])])
}]

export { render, staticRenderFns }